import React, { useState, useEffect } from 'react';
import Input from '../layout/inputs/Input';
import { fetchCompanies } from '../../utils/companies';
import { logger } from '../../utils/logger';
import styles from './Canvasses.module.css';

const CompanySearch = ({ companies, onSelect, loading, error, selectedCompanyId }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);

  useEffect(() => {
    if (searchTerm.trim()) {
      searchCompanies(searchTerm);
    } else {
      setFilteredCompanies(companies);
    }
  }, [searchTerm, companies]);

  const searchCompanies = async (term) => {
    try {
      setSearchLoading(true);
      const result = await fetchCompanies({ 
        search: term.trim(),
        isPublic: true,
        pageSize: 20 
      });
      setFilteredCompanies(result.companies || []);
    } catch (err) {
      logger.error('Error searching companies:', err);
      setFilteredCompanies([]);
    } finally {
      setSearchLoading(false);
    }
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value);
  };

  if (error) {
    return <div className={styles.errorMessage}>{error}</div>;
  }

  return (
    <div className={styles.companySearch}>
      <div className={styles.searchHeader}>
        <Input
          placeholder="Search public companies..."
          value={searchTerm}
          onChange={handleSearchChange}
          className={styles.searchInput}
        />
      </div>
      
      {(loading || searchLoading) && (
        <div className={styles.loadingState}>Searching...</div>
      )}
      
      <div className={styles.companyList}>
        {filteredCompanies.length === 0 && !loading && !searchLoading ? (
          <div className={styles.emptyState}>
            <p>No companies found</p>
            <small>Try adjusting your search terms</small>
          </div>
        ) : (
          filteredCompanies.map(company => (
            <div 
              key={company.id} 
              className={`${styles.companyItem} ${selectedCompanyId === company.id ? styles.selectedItem : ''}`}
              onClick={() => onSelect(company)}
            >
              <div className={styles.companyName}>
                <strong>{company.name}</strong>
                {company.url && (
                  <a href={company.url} target="_blank" rel="noopener noreferrer" className={styles.companyUrl}>
                    {company.url}
                  </a>
                )}
                <span className={styles.companyIndustry}>
                  {company.industry || 'Not specified'}
                </span>
                <span className={`${styles.visibilityBadge} ${company.isPublic ? styles.publicVisibility : styles.privateVisibility}`}>
                  {company.isPublic ? 'Public' : 'Private'}
                </span>
                {company.objective && (
                  <span className={styles.companyObjective}>
                    {company.objective}
                  </span>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CompanySearch;
